import { requester } from "../api"
import { CatGender } from "@/type/cat"

type CatProfileForm = {
  name: string
  gender: CatGender
  color: string
  date_founded: Date | string
  bio: string
  location: {
    lat: number
    lng: number
  }
  images: string[]
}

export const catService = {
  async postCats(data: CatProfileForm) {
    // example of post request
    const response = await requester.post('/cats', data)
    return response
  },
  async putCats(id: string, data: CatProfileForm) {
    // example of put request
    const response = await requester.put(`/cats/${id}`, data)
    return response
  }
}
